import { environment } from 'src/environments/environment.prod';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'src/app/core/models/user';
import { tap, catchError } from 'rxjs/operators';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private url = 'authorized_api/login/';

  private currentUserSubject = new BehaviorSubject<User | null>(null);

  constructor(private http: HttpClient, private storage: Storage) {
    this.initStorage();
  }

  private async initStorage() {
    await this.storage.create();
    const savedUser = await this.storage.get('currentUser');
    if (savedUser) {
      this.currentUserSubject.next(savedUser);
      console.log('Usuario cargado desde Storage (AuthService):', savedUser);
    }
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  login(login: string, password: string): Observable<User> {
    const url = environment.url_web_services_path + this.url;
    return this.http.post<any>(url, { login, password }, { headers: this.getHeaders() })
      .pipe(
        tap(async resp => {
          const actualUser = resp.data;
          if (actualUser && actualUser.rights) {
            actualUser.rights = actualUser.rights.map((r: any) => r.permcode);
          }
          this.currentUserSubject.next(actualUser);
          await this.storage.set('currentUser', actualUser);
          console.log('Usuario logueado normalizado:', actualUser);
        }),
        catchError(err => {
          console.error('Error login:', err);
          throw err;
        })
      );
  }

  logout(): void {
    this.currentUserSubject.next(null);
    this.storage.remove('currentUser');
    console.log('Logout ejecutado');
  }

  getCurrentUser(): User | null {
    return this.currentUserSubject.value;
  }

  hasPermission(permcode: string): boolean {
    const user = this.getCurrentUser();
    if (!user || !user.rights) return false;
    return user.rights.includes(permcode);
  }

  get currentUser$(): Observable<User | null> {
    return this.currentUserSubject.asObservable();
  }

  setCurrentUser(user: User | null) {
    this.currentUserSubject.next(user);
    if (user) {
      this.storage.set('currentUser', user);
    } else {
      this.storage.remove('currentUser');
    }
  }

  // 🔹 NUEVO: async para asegurar usuario desde Storage
  async getCurrentUserAsync(): Promise<User | null> {
    if (this.currentUserSubject.value) return this.currentUserSubject.value;
    await this.initStorage();
    return this.currentUserSubject.value;
  }
}
